import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navbar, Footer } from '../../common/components';
import LoginForm from './components/loginForm/LoginForm';

class Login extends React.Component {
  render() {
    const { message } = this.props.loginForm;

    return (
      <div>
        <Navbar currentPage="login" isLoggedIn={false} activePage="login" />
        <div className="container is-fluid">
          <section>
            <div className="columns">
              <div className="column is-three-quarters is-login-column">
                <h1 style={{ marginBottom: '30px' }}>
                  Retirement Plan Advisors – Advisor Website
                </h1>
                <p className="override-href">
                  Welcome to RPA’s advisor website, where you can access the
                  resources you need to deliver on Our Promise.
                  <br />
                  <br />
                  RPA’s focus on public employees underscores a profound
                  commitment
                  <br />
                  and understanding of the people who make our communities work.
                  <br />
                  <br />
                  We never forget the person sitting across the table
                  <br />
                  is depending on us to protect their hard-earned retirement.
                  <br />
                  <br />
                  We meet face to face with employees, year after year,
                  <br />
                  as they continue to plan their retirement and future financial
                  security.
                  <br />
                  <br />
                  We offer customized investment advice.
                  <br />
                  As an independent firm, we have the freedom to design
                  <br />
                  retirement solutions that are right for each individual.
                  <br />
                  <br />
                  We provide even the smallest communities with the same
                  <br />
                  high-quality retirement plans and advice found on Wall Street.
                  <br />
                  We act with integrity, respect and responsiveness to every
                  individual.
                  <br />
                  <br />
                  Are you a Plan Sponsor or Plan Participant? Click{' '}
                  <a href="http://www.retirementplanadvisors.com/">here</a> to
                  be redirected to our public website.
                </p>
              </div>
              <LoginForm message={message} />
            </div>
          </section>
        </div>
        <Footer />
      </div>
    );
  }
}

Login.propTypes = {
  loginForm: PropTypes.shape({
    message: PropTypes.string,
  }),
};

const mapStateToProps = (state) => {
  const loginForm = state.loginForm;
  return { loginForm };
};

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/pages/login/Login.jsx